export const TAB_NAME_PAGE = 'page'; // 分页标签名称
export const TAB_LABEL_PAGE = '列表'; // 分页标签标题
export const TAB_NAME_DETAILS = 'details'; // 详情标签名称
export const TAB_LABEL_DETAILS = '详情'; // 详情标签标题

export const PATH_PAGE = '/dcim/point-group/page'; // 分页路径
export const PATH_DETAILS = '/dcim/point-group/details'; // 详情路径

export const OPERATION_ADD = 'add'; // 新增操作
export const OPERATION_SHOW = 'show'; // 查看操作
export const OPERATION_EDIT = 'edit'; // 修改操作

export const PERMISSION_ADD = null; // 'point.group.add'; // 新增权限
export const PERMISSION_EDIT = null; // 'point.group.edit'; // 修改权限
export const PERMISSION_DELETE = null; // 'point.group.delete'; // 删除权限


export const EVENT_KEY$$INDEX$$SET_CURRENT_ROW_ID = 'dcim.point-group.index#setCurrentRowId';
export const EVENT_KEY$$INDEX$$SET_DETAILS_FORM_MODEL = 'dcim.point-group.index#setDetailsFormModel';

export const EVENT_KEY$$PAGE$$SET_CURRENT_ROW_ID = 'dcim.point-group.page#setCurrentRowId';
export const EVENT_KEY$$PAGE$$QUERY = 'dcim.point-group.page#query';
export const EVENT_KEY$$PAGE$$REMOVE_VISITED_ID = 'dcim.point-group.page#removeVisitedId';

export const EVENT_KEY$$DETAILS$$SAVE_ADD = 'dcim.point-group.details#saveAdd';
export const EVENT_KEY$$DETAILS$$SAVE_EDIT = 'dcim.point-group.details#saveEdit';
export const EVENT_KEY$$DETAILS$$INVALIDATE = 'dcim.point-group.details#invalidate';
export const EVENT_KEY$$DETAILS$$REVALIDATE = 'dcim.point-group.details#revalidate';
export const EVENT_KEY$$DETAILS$$REMOVE = 'dcim.point-group.details#remove';
